<script setup>
import { NPopover, NProgress, useDialog } from "naive-ui";
import { language } from "@/hooks/util/i18n";
import { useStore } from "@/hooks/stores/global";
import { storeToRefs } from "pinia";
import { send_update } from "@/baseData/update";
import { onMounted, ref, watch, watchEffect, onUnmounted } from "vue";
import { mouseType } from "@/common/index";
import { enter_dfu } from "@/baseData/update";
import { negToUint8, parseHexArray } from "@/common/index";
import { getVersion } from "@/baseData/index";
import { getDevices } from "@/common";
import { reqInitData } from "../baseData/system";
import { reportParams, getCheckSum } from "../common/index.js";
const dialog = useDialog();
const main = useStore();
const { languageValue, updatePercentage, mouseData, dfuData, device } =
  storeToRefs(main);
const bin_data = ref([]);
const is_new_version = ref(false);
onMounted(async () => {
  if (device.value) {
    // 读取鼠标dpi的数据
    let { reportId, reportData } = reportParams(
      reqInitData + getCheckSum(reqInitData)
    );
    // 发送数据

    await device.value.sendReport(reportId, reportData);
  }
});

onUnmounted(() => {
  main.addDpi("");
});

function readBlobAsBinaryString(blob, callback) {
  // 使用FileReader读取Blob数据
  const reader = new FileReader();
  reader.onload = function (e) {
    callback(e.target.result);
  };
  reader.readAsArrayBuffer(blob);
}
const request = async (url) => {
  const response = await fetch(url);
  const blob = await response.blob();

  return blob;
};
const binaryStringFn = (binaryString) => {
  // 处理二进制字符串
  const bytes = new Uint8Array(binaryString);

  const arr = [];

  for (let i = 0; i < bytes.length; i++) {
    arr.push(bytes[i].toString(16).padStart(2, "0"));
  }

  return arr;
};
const firmwareUpdate = async (url) => {
  const blob = await request(url);
  readBlobAsBinaryString(blob, (binaryString) => {
    const arr = binaryStringFn(binaryString);

    bin_data.value = arr;
    version.value = Number(arr[21]) + "." + arr[20].padStart(2, "0");
    if (
      (mouseData.value[10] + mouseData.value[9]).padStart(4, "0") ===
      (arr[21] + arr[20]).padStart(4, "0")
    ) {
      is_new_version.value = false;
    } else {
      is_new_version.value = true;
    }
  });
};
const dongle_bin_data_1 = ref([]);
const dongle_bin_data_2 = ref([]);

const dongleUpdate = async (url) => {
  const blob1 = await request(url[0]);
  const blob2 = await request(url[1]);

  readBlobAsBinaryString(blob1, (binaryString) => {
    dongle_bin_data_1.value = binaryStringFn(binaryString);
    version.value +=
      Number(dongle_bin_data_1.value[21]) +
      "." +
      dongle_bin_data_1.value[20] +
      " ";
  });
  readBlobAsBinaryString(blob2, (binaryString) => {
    dongle_bin_data_2.value = binaryStringFn(binaryString);
    version.value +=
      Number(dongle_bin_data_2.value[21]) + "." + dongle_bin_data_2.value[20];
  });
};
const isDongle = ref(false);
const version = ref("");
onMounted(async () => {
  let data = parseHexArray(getVersion + "20");

  let reportId = data.getUint8(0);
  let reportData = new Uint8Array(data.buffer).slice(1);
  // 发送数据
  await device.value.sendReport(reportId, reportData);
  const url = mouseType();

  if (url && !Array.isArray(url)) {
    isDongle.value = false;
    firmwareUpdate(url);
  }
  if (url && Array.isArray(url)) {
    isDongle.value = true;
    dongleUpdate(url);
  }
});
const isFirst = ref(false);
const clickUpdate = () => {
  if (isFirst.value) return;

  if (isDongle.value) return;
  isFirst.value = true;
  if (!is_new_version.value) {
    dialog.warning({
      showIcon: false,
      closable: false,
      content: language[languageValue.value]["当前固件为最新版本，无需升级"],
      positiveText: "确认",
      positiveButtonProps: {
        color: "#b5d8f1",
        textColor: "black",
        style: {
          width: "62px",
          height: "22px",
        },
      },
      style: {
        background: "#031321",
        width: "134px",
        color: "#b5d8f1",
        width: "454px",
        border: "1px solid #114b5d",
        borderRadius: "8px",
      },
    });
    // alert(language[languageValue.value]["当前固件为最新版本，无需升级"]);
    return;
  }
  send_update(bin_data.value);
};
const clickUpdateDongle = () => {
  if (isFirst.value) return;

  if (!isDongle.value) return;
  isFirst.value = true;
  const currentVersion =
    mouseData.value[21] +
    mouseData.value[22] +
    mouseData.value[9] +
    mouseData.value[10];

  const latestVersion =
    dongle_bin_data_1.value[20] +
    dongle_bin_data_1.value[21] +
    dongle_bin_data_2.value[20] +
    dongle_bin_data_2.value[21];

  // console.log("软件版本", dongle_bin_data_1.value, dongle_bin_data_2.value);
  if (mouseData.value[28] === "00" && currentVersion === latestVersion) {
    dialog.warning({
      showIcon: false,
      closable: false,
      content: language[languageValue.value]["当前接收器为最新版本,无需升级"],
      positiveText: "确认",
      positiveButtonProps: {
        color: "#b5d8f1",
        textColor: "black",
        style: {
          width: "62px",
          height: "22px",
        },
      },
      style: {
        background: "#031321",
        width: "134px",
        color: "#b5d8f1",
        width: "454px",
        border: "1px solid #114b5d",
        borderRadius: "8px",
      },
    });
    // alert(language[languageValue.value]["当前接收器为最新版本,无需升级"]);
    return;
  }
  // return
  if (device.value.productId == 1832 && mouseData.value[28] === "00") {
    enter_dfu("3d", dongle_bin_data_1.value);
    let timer = setInterval(() => {
      if (dfuData.value.length) {
        // location.reload();

        getDevices(false);

        // 获取最新版本
        setTimeout(async () => {
          let data = parseHexArray(getVersion + "20");

          let reportId = data.getUint8(0);
          let reportData = new Uint8Array(data.buffer).slice(1);
          // 发送数据
          await device.value.sendReport(reportId, reportData);
        }, 1200);
        // 更新dongle芯片1
        setTimeout(() => {
          if (mouseData.value[28] === "01" || mouseData.value[16] === "01") {
            if (device.value.productId == 2088) {
              send_update(dongle_bin_data_2.value);
            } else {
              send_update(dongle_bin_data_1.value, "3d", "be").then(() => {
                send_update(dongle_bin_data_2.value);
              });
            }
          }
        }, 1800);
        clearInterval(timer);
      }
    }, 100);
  }

  if (mouseData.value[28] === "01" || mouseData.value[16] === "01") {
    if (device.value.productId == 2088) {
      send_update(dongle_bin_data_2.value);
    } else {
      send_update(dongle_bin_data_1.value, "3d", "be").then(() => {
        send_update(dongle_bin_data_2.value);
      });
    }
  }
};
</script>

<template>
  <div class="box">
    <div class="linear" style="margin-top: 24px"></div>
    <div class="top">
      <n-popover>
        <template #trigger>
          <img src="@/images/firmware.png" alt="" style="margin-right: 48px" />
        </template>
        <span>{{ language[languageValue]["固件"] }}</span>
      </n-popover>

      <span class="middle">{{ language[languageValue]["固件"] }}</span>
    </div>
    <div>
      <div class="title">
        {{ language[languageValue]["鼠标固件版本"]
        }}{{ isDongle ? "" : version }}
      </div>
      <div style="margin-bottom: 10px">鼠标固件升级提示：需使用有线模式</div>
      <n-progress
        type="line"
        :percentage="isDongle ? 0 : updatePercentage"
        :border-radius="4"
        :fill-border-radius="0"
        indicator-text-color="#fff"
      />

      <div
        style="text-align: right; margin-top: 10px; cursor: pointer"
        @click="clickUpdate"
      >
        {{ isDongle ? "" : language[languageValue]["下载"] }}
      </div>
    </div>
    <div class="marginTop" style="margin-top: 25px">
      <div class="title">
        {{ language[languageValue]["接收器固件版本"]
        }}{{ isDongle ? version : "" }}
      </div>
      <div style="margin-bottom: 10px">接收器固件升级提示：需使用2.4G模式</div>
      <n-progress
        type="line"
        :percentage="isDongle ? updatePercentage : 0"
        :border-radius="4"
        :fill-border-radius="0"
        indicator-text-color="#fff"
      />
      <div
        style="text-align: right; margin-top: 10px; cursor: pointer"
        @click="clickUpdateDongle"
      >
        {{ isDongle ? language[languageValue]["下载"] : "" }}
      </div>
    </div>
    <!-- <div class="marginTop">
      <div style="margin-bottom: 10px">驱动版本Beta1.0.1.6</div>
      <n-progress
        type="line"
        :percentage="60"
        :indicator-placement="'inside'"
        processing
      />
      <div style="text-align: right; margin-top: 10px">下载</div>
    </div> -->
  </div>
</template>

<style lang="less" scoped>
.box {
  color: #fff;

  width: 288px;
  .title {
    font-family: PingFang;
    font-weight: bold;
    font-size: 14px;
    color: #b5d8f1;
  }
  .linear {
    width: 288px;
    height: 3px;
    background: linear-gradient(90deg, #457287, #387d8c, #385d65);
  }
  .top {
    display: flex;
    align-items: center;
    background: linear-gradient(66deg, #020612, #16221e);
    margin-bottom: 43px;

    height: 64px;
    border-bottom-right-radius: 15px;
    border-bottom-left-radius: 15px;
    padding: 0 18px 0 26px;

    .middle {
      position: relative;
      font-family: "PingFang";
      font-weight: bold;
      font-size: 17px;
      color: #b5d8f1;
    }
  }
  .header {
    height: 50px;
    line-height: 50px;
    border-radius: 10px;
    text-align: center;
    background-color: #15211d;
  }
  .marginTop {
    margin-top: 10px;
  }
}
</style>
